import { useState, useEffect } from 'react';
import { selectUsers } from '../store/usersSlice';
import { useSelector } from 'react-redux';
import { ref, onValue } from "firebase/database";
import { getCollabList, deleteNonOwnedList, db } from '../../firebase';
import styles from './AddedLists.module.css';
import { Link } from 'react-router-dom';

const AddedLists = () => {
  const user = useSelector(selectUsers);
  const [movieList, setMovieList] = useState({});

  useEffect(() => {
    if (!user?.currentUser?.collabId) return;

    const collabNodeRef = ref(db, `collab/${user.currentUser.collabId}`);

    const unsubscribe = onValue(
      collabNodeRef,
      (snap) => {
        const data = snap.val() || {};   // { [listId]: true, ... }
        const listArray = Object.entries(data).map(([listId, value]) => ({
          listId,
          ...value,
        }));
        setMovieList(listArray);
      },
      (err) => console.error("collab listener error", err)
  );

  return () => unsubscribe();
  }, [user?.currentUser?.collabId]);

  // Need to add delete here
  const handleDeleteList = async (movie) => { 
    const { listId } = movie;

    deleteNonOwnedList(user.currentUser.collabId, listId, user.currentUser.id);
  }

  // Need a retrieved added lists function
  // const retrieveList = async () => {
  //   const lists = await getCollabList(user.currentUser.collabId);
  //   setMovieList(lists); 
  // }

  const listInfo = Object.values(movieList);

  return (
    <div className="Movie-List">
      <h1>Hello, {user.currentUser.name}!</h1>
      <div>
        <div className={styles.list_grid}>
          {listInfo.length > 0 ? (
            Object.entries(listInfo).map(([movieId, movie]) => (
              <div key={movieId} className={styles.listItem}>
                <Link to={`/list/${movie?.listId?.slice(0,20)}`} className={styles.link}>{movie?.listName}</Link>
                <button
                  className={styles.deleteButton}
                  onClick={() =>
                  handleDeleteList(movie)}
                  aria-label="Delete list"
                >
                  <p style={{ marginBottom: 17 }}>x</p>
                </button>
              </div>
            ))
          )
          :
          <p>No added lists</p>
          }
        </div>
      </div>
    </div>
  )
}

export default AddedLists;
